export default from './LanguageSelector';


// WEBPACK FOOTER //
// ./src/components/LanguageSelector/index.js


// WEBPACK FOOTER //
// webpack:///src/components/LanguageSelector/index.js